
export default function measureClear(viewer) {
    if (viewer) {
        let scene = viewer.getActualDimensionScene();
        if (scene) {
            scene.getMeasureDataLayer().clear()
        }
    }
}
